const COLUMN_COUNT = 3

export {
    COLUMN_COUNT
}